import PropTypes from 'prop-types';
// @mui
import { Box, Stack, Typography } from '@mui/material';
// components
import CustomModal from '../../../components/CustomModal';
import { GoldBorderButton } from '../../../components/nav-section/vertical/style';
import useLocales from '../../../hooks/useLocales';

// ----------------------------------------------------------------------

export default function RegisterErrorDialog({ open, message, onClose }) {
  const { translate } = useLocales();

  return (
    <CustomModal maxWidth="xs" open={open} onClose={onClose} paperPropsSx={{ p: 1 }}>
      <Box sx={{ p: 3 }}>
        <Stack spacing={1} sx={{ alignItems: 'center', mb: 3 }}>
          <Typography className="gold-text" variant="h6" fontWeight={900} sx={{ textAlign: 'center' }}>
            {translate('registration_failed')}
          </Typography>
          <Typography variant="body2" sx={{ color: '#c9c9c9', textAlign: 'center' }}>
            {message}
          </Typography>
        </Stack>

        <GoldBorderButton fullWidth size="large" onClick={onClose}>
          <Typography className="gold-text" fontWeight={900}>
            {translate('close')}
          </Typography>
        </GoldBorderButton>
      </Box>
    </CustomModal>
  );
}

RegisterErrorDialog.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string,
  onClose: PropTypes.func,
};
